import React from "react";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_Base_Url;
// Add a request interceptor

axios.interceptors.request.use(
  async (config) => {
    document.body.classList.add("loading-indicator-api");
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    document.body.classList.remove("loading-indicator-api");
    return response;
  },
  function (error) {
    document.body.classList.remove("loading-indicator-api");
    return Promise.reject(error);
  }
);

export async function getApi(path, config = {}) {
  try {
    const result = await axios.get(path, config);
    return Promise.resolve(result.data.response);
  } catch (err) {
    console.error(err);
    return Promise.reject(err.response.data.error);
  }
}
export async function postApi(path, body, config = {}) {
  try {
    const result = await axios.post(path, body, config);
    return Promise.resolve(result.data.response);
  } catch (err) {
    console.error(err);
    return Promise.reject(err.response.data.error);
  }
}

export default axios;
